<template>
  <div :class="{ 'd-s': !selectArr.includes(searchType) }">
    <div>
      <el-input v-if="searchType == 'text' || searchType == 'link'" v-model="form[searchCode]"
        placeholder="请输入内容"></el-input>
      <div v-if="selectArr.includes(searchType) && pullDownData" class="pullDown">
        <el-radio-group v-model="form[searchCode]" v-for="it in pullDownData.list" :key="it.value">
          <el-radio :label="it.label" :value="pullDownData.type"></el-radio>
        </el-radio-group>
      </div>
      <el-date-picker v-if="searchType === 'daterange' || searchType === 'date' || searchType === 'datetime'"
        v-model="form[searchCode]" type="daterange" unlink-panels format="yyyy-MM-dd" value-format="yyyy-MM-dd"
        range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期" style="width: 100%"></el-date-picker>
      <el-cascader v-else-if="(searchType === 'select-m' || searchType === 'cascader') && pullDownData.list" clearable
        style="width: 100%" :options="pullDownData.list" :props="{ checkStrictly: true }" :ref="'cascaderRef'"
        v-model="form[searchBianma]" :placeholder="`请选择`" @change="selectCodeChange"></el-cascader>
    </div>
    <div class="footer">
      <el-button size="mini" @click="query(true)">重置</el-button>
      <el-button type="primary" size="mini" @click="query()">确定</el-button>
    </div>
  </div>
</template>
<script>
import { mapState, mapGetters } from 'vuex'
export default {
  name: 'JjSearch',
  components: {},
  props: {
    searchInfo: {
      type: Object,
      default: () => { }
    },
    pullDownInfo: {
      type: Object,
      default: () => { }
    },
    searchParams: {
      type: Object,
      default: () => { }
    }
  },
  data() {
    return {
      searchType: '',
      searchCode: '',
      searchBianma: '',
      selectArr: [
        // 'cascader',
        'select',
        'filter-select',
        'select-filter',
        'select-link',
        // 'select-m',
        'select-edit',
        'auditFlow'
      ],
      pullDownData: {},
      form: {},
      searchList: []
    }
  },
  computed: {
    ...mapGetters(['isAdmin', 'userInfo']),
    ...mapState(['sysCode', 'currentArea'])
  },
  watch: {
    searchParams: {
      deep: true,
      immediate: true,
      handler(data) {
        this.form = Object.assign({}, data)
      }
    },
    pullDownInfo: {
      deep: true,
      immediate: true,
      handler(data) {
        this.pullDownData = data
      }
    },
    searchInfo: {
      deep: true,
      immediate: true,
      handler(v = {}) {
        // console.log(v)
        this.searchType = v.type
        this.searchCode = v.code
        this.searchBianma = v.bianma
      }
    }
  },
  created() { },
  mounted() { },
  methods: {
    selectCodeChange() {
      let node = this.$refs['cascaderRef'].getCheckedNodes()[0]
      if (node) {
        this.form[this.searchCode] = node.pathLabels.join('/') + '*'
      }
    },
    query(val) {
      if (val) {
        this.form[this.searchCode] = ''
        this.form[this.searchBianma] = ''
      }
      let params = Object.assign(this.searchParams, this.form)
      Object.keys(params).filter(n => {
        if (Array.isArray(params[n])) {
          if (this.searchType === 'daterange' || this.searchType === 'date' || this.searchType === 'datetime') {
            params[n] = params[n].join(',')
          } else {
            params[n] = params[n].length > 0 ? params[n][params[n].length - 1] : null
          }
        }
        if (params[n] === '') {
          delete params[n]
        }
        return true
      })
      this.$emit('searchData', params)
    }
  }
}
</script>
<style scoped lang="scss">
.d-s {
  display: flex;
  align-items: center;
  justify-items: center;
}

.el-select,
.el-cascader,
.el-date-editor,
.el-input {
  width: 260px !important;
  height: 30px !important;
  line-height: 30px !important;

  ::v-deep .el-input__inner {
    height: 30px !important;
    line-height: 30px !important;
    color: #333;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  ::v-deep .el-select__tags {
    top: 66%;
    height: 30px;
    line-height: 30px;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
  }

  ::v-deep .el-input__icon {
    line-height: 30px;
  }
}

.pullDown {
  // max-height: 220px;
  max-height: 50vh;
  overflow: auto;
  display: flex;
  flex-direction: column;
}

::v-deep .el-radio__inner {
  border-radius: 0;
}

::v-deep .el-radio-group {
  padding: 6px 10px;
}

::v-deep .el-range__icon {
  line-height: 24px !important;
}

::v-deep .el-range-separator {
  line-height: 22px !important;
}

.footer {
  margin-left: 10px;
  text-align: right;
}

::v-deep .el-radio__label {
  font-size: 15px !important;
}
</style>
